import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import MainContainer from "../../layout/MainContainer";
import UserGraph from "../../features/dashboard/customerGraph";
import BookingsGraph from "../../features/dashboard/issuesGraph";
import VenuesGraph from "../../features/dashboard/maintenanceTeamGraph";
import EarningsGraph from "../../features/dashboard/earningGraph";
import { useLazyGetBookingGraphQuery, useLazyGetDashboardQuery, useLazyGetVenueGraphQuery, DashboardSummaryResponse, } from "../../services/dashboard";
import { showError } from "../../constants/toasts";
import useAuth from "../../hooks/useAuth";

const Dashboard = () => {
  const navigate = useNavigate();
  const [getDashboard] = useLazyGetDashboardQuery();
  const [VenueGraphData] = useLazyGetVenueGraphQuery();
  const [bookingGraphData] = useLazyGetBookingGraphQuery();
  const [dashnordData, setDashboardData] = useState<DashboardSummaryResponse | null>(null);
  const [bookingGraph, setBookingGraph] = useState<any[]>([]);
  const [venueGraph, setVenueGraph] = useState<any[]>([]);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalCount, setTotalCount] = useState(0);
  const [selectedId, setSelectedId] = useState("");
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const user = useAuth();


  const DashboardData = async () => {
    try {
      const response = await getDashboard({
        from: page,
        size: pageSize,
        search: searchTerm,
        country: user?.accessRoleId?.country || "",
      }).unwrap();

      if (response?.statusCode === 200) {
        setDashboardData(response.data || null);
      }
    } catch (error: any) {
      showError(error?.data?.message || "Failed to fetch dashboard");
    }
  };
  const VenueGraph = async () => {
    try {
      const response = await VenueGraphData({
        from: page,
        size: pageSize,
        search: searchTerm,
         categoryType:"",
           type:"daily"
      }).unwrap();

      if (response?.statusCode === 200) {
        // Support both array and wrapped-object shapes
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const payload: any = response as any;
        setVenueGraph(Array.isArray(payload) ? payload : payload?.data || []);
      }
    } catch (error: any) {
      showError(error?.data?.message || "Failed to fetch dashboard");
    }
  };
  const BookingGraph = async () => {
    try {
      const response = await bookingGraphData({
        from: page,
        size: pageSize,
        search: searchTerm,
        categoryType:"",
          type:"daily"
      }).unwrap();

      if (response?.statusCode === 200) {
        // Support both array and wrapped-object shapes
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const payload: any = response as any;
        setBookingGraph(Array.isArray(payload) ? payload : payload?.data || []);
      }
    } catch (error: any) {
      showError(error?.data?.message || "Failed to fetch dashboard");
    }
  };
useEffect(() => {
  DashboardData();
  VenueGraph()
  BookingGraph()
}, [searchTerm, page, pageSize,user]);
  return (
    <MainContainer>
      <div className="main_title">
        <h1>Dashboard</h1>
      </div>
      <div className="stats_boxes gap_m">
        <div className="cards" onClick={() => navigate("/manage-customers")}>
          <figure>
            <img src="/static/images/user_icon.svg" alt="" />
          </figure>
          <h2>{dashnordData?.totalUser?.value ?? 0}</h2>
          <p>Total Users</p>
        </div>
        <div className="cards" onClick={() => navigate("/manage-bookings")}>
          <figure>
            <img src="/static/images/offer_icon.svg" alt="" />
          </figure>
          <h2>{dashnordData?.totalBooking?.value ?? 0}</h2>
          <p>Total Bookings</p>
          <div style={{ fontSize: 12, color: '#717171', marginTop: 4 }}>
            <span>Venue: {dashnordData?.totalBookingVenue?.value ?? 0}</span> | <span>Storage: {dashnordData?.totalBookingStorage?.value ?? 0}</span>
          </div>
        </div>
        <div className="cards" onClick={() => navigate("/manage-bookings")}>
          <figure>
            <img src="/static/images/offer_icon.svg" alt="" />
          </figure>
          <h2>{dashnordData?.totalBookingVenue?.value ?? 0}</h2>
          <p>Venue Bookings</p>
        </div>
        <div className="cards" onClick={() => navigate("/manage-bookings")}>
          <figure>
            <img src="/static/images/offer_icon.svg" alt="" />
          </figure>
          <h2>{dashnordData?.totalBookingStorage?.value ?? 0}</h2>
          <p>Storage Bookings</p>
        </div>
        <div className="cards" onClick={() => navigate("/manage-categories")}>
          <figure>
            <img src="/static/images/category_icon.svg" alt="" />
          </figure>
          <h2>{dashnordData?.totalVenueListed?.value ?? 0}</h2>
          <p>Total Venues Listed</p>
        </div>
        <div className="cards" onClick={() => navigate("/manage-categories")}>
          <figure>
            <img src="/static/images/category_icon.svg" alt="" />
          </figure>
          <h2>{dashnordData?.totalStorageListed?.value ?? 0}</h2>
          <p>Total Storages Listed</p>
        </div>
        <div className="cards" onClick={() => navigate("/manage-payments")}>
          <figure>
            <img src="/static/images/money_icon.svg" alt="" />
          </figure>
          <h2>$0</h2>
          <p>Total Earnings</p>
        </div>
        <div className="cards" onClick={() => navigate("/manage-subadmin")}>
          <figure>
            <img src="/static/images/subadmin_icon.svg" alt="" />
          </figure>
          <h2>{dashnordData?.totalSubadmin?.value ?? 0}</h2>
          <p>Sub-admins</p>
        </div>
      </div>
      <div className="grid_sc gap_m">
        <UserGraph />
        <BookingsGraph />
        <VenuesGraph />
        <EarningsGraph />
      </div>
    </MainContainer>
  );
};

export default Dashboard;
